import http from '../httpConfig';
import { API_ENDPOINTS } from '../utils/apiConstant';

export interface PaymentListPayload {
  page?: number;
  limit?: number;
  tenantId?: number;
  subscriptionId?: number;
  dateFrom?: string;
  dateTo?: string;
}

export interface PaymentFormPayload {
  subscription_id: number;
  amount: number;
  currency_id: number;
  payment_date: string;
  payment_mode: 'cash' | 'bank_transfer' | 'cheque' | 'other';
  reference_no?: string;
  notes?: string;
}

const list = (payload: PaymentListPayload) => {
  const { page, limit, tenantId, subscriptionId, dateFrom, dateTo } = payload;
  const params: Record<string, string> = {};
  if (page) params.page = String(page);
  if (limit) params.limit = String(limit);
  if (tenantId) params.tenantId = String(tenantId);
  if (subscriptionId) params.subscriptionId = String(subscriptionId);
  if (dateFrom) params.dateFrom = dateFrom;
  if (dateTo) params.dateTo = dateTo;
  const query = new URLSearchParams(params).toString();
  return http.get(`${API_ENDPOINTS.payments}${query ? `?${query}` : ''}`);
};

const get = (id: number | string) => http.get(`${API_ENDPOINTS.payments}/${id}`);

const create = (payload: PaymentFormPayload) => http.post(API_ENDPOINTS.payments, payload);

const resend = (id: number | string) => http.post(`${API_ENDPOINTS.payments}/${id}/resend`);

const PaymentService = { list, get, create, resend };

export default PaymentService;
